import { render, staticRenderFns } from "./SessionsTableDetail.vue?vue&type=template&id=6975caa5&scoped=true&"
import script from "./SessionsTableDetail.vue?vue&type=script&lang=js&"
export * from "./SessionsTableDetail.vue?vue&type=script&lang=js&"
import style0 from "./SessionsTableDetail.vue?vue&type=style&index=0&id=6975caa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975caa5",
  null
  
)

export default component.exports